import { Box, Typography } from '@mui/material';
import { colors } from '../theme';
import styled from 'styled-components';

import { ReactComponent as DeleteIcon } from '../../src/assets/icons/delete-icon.svg';

const ClassCard = (props) => {
    const { term, dayClass, lastEdit, onLoadPlan } = props;

    return (
        <Box
            onClick={onLoadPlan}
            sx={{
                background: 'white',
                width: '48%',
                padding: '12px',
                position: 'relative',
                display: 'inline-block',
                marginBottom: '15px',
                borderRadius: '5px',
                cursor: 'pointer',

                '&:hover': {
                    boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.05)',
                },
            }}
        >
            <Typography variant="h4" sx={{ color: colors.blue.main }}>
                {term}
            </Typography>
            <Typography variant="body1" sx={{ fontWeight: 500, color: colors.grey.dark, marginBottom: '20px' }}>
                {dayClass} Class
            </Typography>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                <Typography variant="body2" sx={{ color: colors.grey.medium }}>
                    Last Edit: {lastEdit}
                </Typography>
                <SVGIcon>
                    <DeleteIcon />
                </SVGIcon>
            </Box>
        </Box>
    );
};

export default ClassCard;

const SVGIcon = styled.div`
    color: ${colors.grey.dark};
    display: flex;
    justify-content: center;

    svg {
        width: 20px;
        height: auto;
    }
    &:hover {
        color: ${colors.red.main};
    }
`;
